import { useLocation } from 'react-router-dom';
import { ButtonLink } from '../../Form/Button';
import SanitizedHtml from '../../SanitizedHtml/SanitizedHtml';
import './ProductBoxBanner.css';
import { CmsMeta } from '../cmsMeta';

export type ProductBoxBannerProps = {
	image: string;
	badgeText: string;
	html: string;
	ctaText: string;
	ctaLink: string;
	logo?: string;
	savedComponentId?: string | number;
	savedComponentName?: string;
};

export const ProductBoxBanner = ({
	image,
	badgeText,
	html,
	ctaLink,
	ctaText,
	logo,
	savedComponentId,
	savedComponentName,
}: ProductBoxBannerProps) => {
	const { pathname } = useLocation();
	const pageSlug = pathname.replace(/^\/+/, '');

	const trackProductBannerClick = () => {
		if (typeof window === 'undefined' || typeof window.plausible === 'undefined') return;

		window.plausible('Product Banner Click', {
			props: {
				savedComponentId,
				savedComponentName,
				pageSlug,
			},
		});
	};

	return (
		<div className="kg-card">
			<div className="kg-card__image" style={{ backgroundImage: `url(${image})` }}>
				<div className="kg-card__badge-wrapper">
					{logo ? (
						<div className="kg-card__logo-wrapper">
							<img src={logo} alt="" className="kg-card__logo" />
						</div>
					) : (
						<span className="kg-card__badge">{badgeText}</span>
					)}
				</div>
			</div>

			<div className="kg-card__content">
				<SanitizedHtml html={html} className="kg-card__html" />
				<ButtonLink className="kg-card__cta" linkTo={ctaLink} onClick={trackProductBannerClick}>
					{ctaText} →
				</ButtonLink>
			</div>
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		'A banner sized like a product box, for inside a GridBannerPlacement on a category or brand page: a picture on top with a brand logo or a short badge over it, then a heading and a line of text, and a button. `logo` wins over `badgeText` - leave logo empty to show the badge. `html` takes simple html, so an <h2> and a <p>; `ctaLink` is a path on the site, and the button text gets an arrow added. Clicks are counted in Plausible as Product Banner Click.',
	example: [
		'ProductBoxBanner',
		{
			image: 'https://cdn.ondio.com/assets/bfc7c843bb2b4fdcb588a2bff697bd6e.jpg',
			logo: 'https://cdn.ondio.com/assets/ddc24d4ab04e4fcd8c361c24ccb21e5e.jpg',
			badgeText: '',
			html: '<h2>Välj ikonisk kvalitet med Rapid</h2><p>Rapid erbjuder hållbara häftare, hålslag och verktyg i tidlös svensk kvalitet för pålitlig användning varje dag.</p>',
			ctaText: 'Se Rapid',
			ctaLink: '/skrivbordet-halslag-c-3930000_3931800_3931826.html?brand=Rapid',
		},
	],
};
